import { render, staticRenderFns } from "./IcnRegion.vue?vue&type=template&id=0e1268b6&"
import script from "./IcnRegion.vue?vue&type=script&lang=ts&"
export * from "./IcnRegion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports